<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!communication">
      <span class="loader"></span>
    </span>
    <communication-form
      v-if="communication"
      :loading="loading"
      :communicationData="communication"
      :formErrors="formErrors"
      @communicationSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import CommunicationForm from "../partials/CommunicationForm.vue";

export default {
  layout: "DashboardLayout",

  components: { CommunicationForm },

  mixins: [alertLeave],

  props: {
    communicationId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      communication: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("communications/get", this.communicationId);
        this.communication = this.$store.getters["communications/communication"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async handleSubmit(communication) {
      this.loading = true;
      let communicationData = cloneDeep(communication);
      communicationData.relationshipNames = ["contact","properties"];

      try {
        await this.$store.dispatch("communications/update", communicationData);
        this.$notify({
          type: "success",
          message: this.$t("COMMUNICATIONS.COMMUNICATION_UPDATED"),
        });
        const communication = this.$store.getters["communications/communication"];
        this.$emit("onViewCommunication", communication, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
